"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getErrorForNode_1 = __importDefault(require("./getErrorForNode"));
const firstOutputOfSample = (value) => Array.isArray(value) ? lodash_1.head(value) || {} : value;
const sample = (node, taskState) => {
    if (node && taskState) {
        const nodeId = node.id;
        const input = taskState.input || {};
        return {
            input: input[nodeId],
            output: firstOutputOfSample((taskState.output || {})[nodeId]),
            status: (taskState.statuses || {})[nodeId],
            error: getErrorForNode_1.default(taskState, node.id),
        };
    }
    else {
        return {
            input: null,
            output: null,
            status: null,
            error: null,
        };
    }
};
exports.default = sample;
